/**
 * Converts a kebab-case string to camelCase
 * @param str - The string to convert
 * @returns The camelCase string
 * Example: kebabToCamel("my-kebab-string") -> "myKebabString"
 */

export const kebabToCamel = (str: string): string =>
  str?.toLowerCase().replace(/[-_][a-z0-9]/g, (group: string) => group.slice(-1).toUpperCase())
